var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wtf"}},[_c('vue-dropzone',{ref:_vm.id,class:`
	  ${_vm.isError ? 'err-border-red ' : ''}
	  ${_vm.isDark ? 'dropzone-dark ' : ''}
	  ${_vm.customClassNames}
	`,attrs:{"id":_vm.id,"options":_vm.dropzoneOptions,"useCustomSlot":_vm.useCustomSlot},on:{"vdropzone-success":_vm.onSuccess,"vdropzone-removed-file":_vm.handleRemovedFile,"vdropzone-files-added":_vm.handleFilesAdded,"vdropzone-error":_vm.handleDropzoneError}},[_vm._t("default")],2),(_vm.invalidFileError)?_c('p',{staticStyle:{"color":"red"}},[_vm._v("File type is not allowed.")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }